import { useState } from "react";
import { guideFaqs } from "@/mocks/siteContent";

export default function GuideFaq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (index: number) => {
    setOpenIndex((current) => (current === index ? null : index));
  };

  return (
    <section id="guide" className="scroll-mt-16 border-y border-background-200 bg-background-100 py-14 md:py-20">
      <div className="mx-auto grid max-w-8xl gap-10 px-4 md:px-8 lg:grid-cols-[0.8fr_1.2fr]">
        <div>
          <span className="text-sm font-medium text-accent-700">观影指南</span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            关于在线观看与资源整理，你可能想问
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            这里汇总了使用星辰影院时最常见的问题，涵盖观看方式、筛选技巧、更新节奏与设备适配。如果还有疑问，欢迎从页面底部的入口继续了解。
          </p>
          <div className="mt-6 flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-4">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-primary-800">
              <i className="ri-lightbulb-flash-line text-xl"></i>
            </span>
            <p className="text-sm leading-relaxed text-foreground-700">
              小技巧：在影视库先按「分类」缩小范围，再用「类型」和「评分最高」排序，几秒钟就能锁定想看的片子。
            </p>
          </div>
        </div>

        <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
          {guideFaqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div key={faq.question}>
                <button
                  type="button"
                  onClick={() => toggle(index)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100"
                >
                  <span className="font-heading text-base font-semibold text-foreground-950">{faq.question}</span>
                  <i
                    className={`${
                      isOpen ? "ri-subtract-line" : "ri-add-line"
                    } shrink-0 text-lg text-primary-600`}
                  ></i>
                </button>
                {isOpen && (
                  <div className="px-5 pb-5">
                    <p className="text-sm leading-relaxed text-foreground-600">{faq.answer}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}